<template>
	<div>
		<myheader :backFlag="true" :myBackgroundColor="'#98e2af'" headTitle="签约减碳助力值"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back" style="background-color: #98e2af;"></div>
			<div class="header_extend_content_height" style="height: 86vh;overflow-y: auto;">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div class="all_tips_content_card_padding8 ">
						<div class="all_text_center">
							<div class="text14 textcolor666 font_weight_bold margin_bottom_10">在石化e签平台，您已累计减少碳排放</div>
							<div class="text24 textcolor98e2af font_weight_bold margin_bottom_10">{{contractScore+' g'}}
							</div>
						</div>
						<van-list v-model="listloading" :finished="listfinished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div style="width: 90%;margin: 0 5% 1rem;" v-for="(item,index) in list" :key="index">
								<div class="all_height20 display_flex backgroundC_98e2af"
									style="border-radius: .2rem;align-items: center;">
									<span class="display_block text14 textcolor333 font_weight_bold"
										style="width: 35%;margin-left: 5%;">{{Tool.isNoEmpty(item.year)?item.year:'2024'}}</span>
									<span class="display_block text12 textcolor333 all_text_right"
										style="width: 48%;">{{'节能减碳&nbsp;'+(Tool.isNoEmpty(item.contractScore)?item.contractScore:'0')+'g'}}</span>
									<span style="width: 2rem;height: 2rem;" @click="showItem(item,index)">
										<img src="@/assets/images/arrow_up.svg" :class="{rotate:item.show}"
											style="width: .6rem;height:.6rem;margin: .7rem 0 0 .7rem;" />
									</span>
								</div>
								<div v-show="item.show">
									<div class="all_height20 margin_top_10" style="padding: 0 .5rem;"
										v-for="(child,cindex) in item.list" :key="cindex">
										<div class="display_flex">
											<span class="display_block text12 textcolor666"
												style="width: 70%;word-break: break-all;">{{Tool.isNoEmpty(child.contractName)?child.contractName:''}}</span>
											<span class="display_block text12 textcolor333 font_weight_bold"
												style="width: 30%;text-align: right;">{{'+'+(Tool.isNoEmpty(child.contractScore)?child.contractScore:'0')+'g'}}</span>
										</div>
										<div class="margin_bottom_3 text12 textcolor666 margin_top_5">
											{{Tool.isNoEmpty(child.monthsDay)?child.monthsDay:''}}
										</div>
									</div>
									<div v-if="index != list.length-1"
										class="margin_top_10 all_text_center text12 textcolor98e2af">
										<span
											style="border: 1px solid #98e2af;border-radius: .8rem;padding: .3rem .5rem;"
											@click="loadShowMore(index)">展开更多</span>
									</div>
								</div>
							</div>
						</van-list>
						<van-empty style="margin-top: 10vh;" description="暂无数据" v-show="list.length===0" />
					</div>
				</van-pull-refresh>
			</div>
			<!-- <div style="position: fixed; bottom: 1rem; left: 0;right: 0;">
				<span class="text12 textcolor98e2af all_text_center display_block"
					style="position: relative; width: 60%;left: 20%;">签约减碳计算模型由石化e签联合北京绿色交易所提供</span>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Empty,
		PullRefresh,
		List,
	} from 'vant';
	export default {
		name: 'energyconservationselflist',
		components: {
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
			[List.name]: List,
		},
		data() {
			return {
				//
				contractScore: '',
				//企业id
				staffCode: '',
				//每页数量
				pageSize: 10,
				//第几页
				pageNum: 0,
				//是否刷新
				refreshing: false,
				//加载中
				listloading: false,
				//是否全部加载
				listfinished: false,
				//
				list: [],
			}
		},
		methods: {
			//y
			showItem(item, index) {
				if (item.show) {
					item.show = !item.show
				} else {
					if (!item.list || (Array.isArray(item.list) && item.list.length === 0)) {
						this.queryContractScoreYearItems(index)
					} else {
						item.show = !item.show
					}
				}
			},
			//
			loadShowMore(index) {
				if (this.list[index + 1].list) {
					//this.list[index].show = false
					this.list[index + 1].show = true
				} else {
					this.queryContractScoreYearItems(index + 1)
				}
			},
			//
			onRefresh() {
				this.$store.dispatch(this.$LoadShow, true)
				this.listfinished = false;
				// 将 loading 设置为 true，表示处于加载状态
				this.listloading = true;
				this.pageNum = 0
				this.onLoad();
			},
			//
			onLoad() {
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.pageNum++
				this.queryContractScoreYear()
			},
			//查询当前登陆人某一年签约的合同碳排放明细
			queryContractScoreYearItems(index) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/score/m/api/queryContractScoreYearItems', {
						year: this.list[index].year
					})
					.then(res => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							//this.list[index].show = false
							this.list[index].list = res.data.records
							this.list[index].show = true
						} else {
							this.$Toast('未获取到更多数据！')
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
					})
			},
			//查询登陆人以年为维度的合同碳排放
			queryContractScoreYear() {
				this.$post('/score/m/api/queryContractScoreYear', {
					staffCode: this.$store.state.userInfo.staffCode,
					pageParams: {
						current: this.pageNum,
						desc: true,
						orderBy: "",
						size: this.pageSize
					}
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						res.data.records.forEach(item => {
							item.show = false
							item.list = []
						})
						this.list = this.list.concat(res.data.records);
						if (this.pageNum === 1) {
							if (this.list[0]) {
								this.list[0].show = true
								this.queryContractScoreYearItems(0)
							}
						}
						//加载状态结束
						this.listloading = false;
						//数据全部加载完成
						if (this.list.length >= res.data.total) {
							this.listfinished = true;
						}
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
				})
			},
			//初始化
			init() {
				this.contractScore = this.$route.query.contractScore
				this.onRefresh()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.energyRotate {
		transform: rotate(360deg);
	}
</style>